import { KaminMonitoringRow } from "../../Requests/kamin2leg";

export const competitionStatusNames = {
  Insensitive: "بی‌حس",
  AtFloor: "چسبیده به کف",
  AbsoluteWinner: "برنده مطلق (چسبیده به سقف)",
  AbsoluteLoser: "شکست خورده مطلق",
  Competitive: "قابل رقابت",
  Unopposed: "بی‌رقیب",
};

export function getKaminCompetitionStatus(row: Partial<KaminMonitoringRow>): keyof typeof competitionStatusNames | undefined {
  if (row.competitionStatus && row.competitionStatus in competitionStatusNames) return row.competitionStatus;
  if (row.hasCompetitionPrices === false) return "Unopposed";
  const numeric = (key: string): number | undefined => {
    const value = row[key];
    return typeof value === "number" && Number.isFinite(value) ? value : undefined;
  };
  const aheadPercent = numeric("volumeAheadOfFloorPercent"), maximum = numeric("maxAheadFloorPercent");
  if (aheadPercent != null && maximum != null && aheadPercent > maximum) return "AbsoluteLoser";
  if (row.side !== 1 && row.side !== 2) return undefined;
  const floor = numeric("floorKaminPrice"), ceiling = numeric("ceilingKaminPrice"), ideal = numeric("idealCompetitionPrice");
  if (floor == null || ceiling == null || ideal == null) return undefined;
  const worse = (price: number, other: number) => row.side === 1 ? price < other : price > other;
  const boundary = numeric("competitorBoundaryPrice");
  // Older records use their own recorded prices/volumes, never today's book or the old boolean.
  if (boundary != null && worse(floor, boundary)) {
    const percent = numeric("volumeAheadOfFloorPercent"), threshold = numeric("aheadFloorInsensitivityPercent");
    if (percent == null || threshold == null) return undefined;
    if (percent > threshold) return "Insensitive";
  }
  if (worse(floor, ideal)) return "AtFloor";
  if (worse(ideal, ceiling)) return "AbsoluteWinner";
  return ideal >= Math.min(floor, ceiling) && ideal <= Math.max(floor, ceiling) ? "Competitive" : undefined;
}

export function getKaminRepriceText(row: Partial<KaminMonitoringRow>): string | undefined {
  if (getKaminCompetitionStatus(row) === "AbsoluteLoser") return competitionStatusNames.AbsoluteLoser;
  return row.requiresKaminReprice == null ? undefined : row.requiresKaminReprice ? "بله" : "خیر";
}
